<template>
<div class="form">
<a-card :title="c_title">
    <v-gobackbutton slot="extra" >返回</v-gobackbutton>
        <a-form-model :model="appData" ref="ruleForm" :rules="rules" :layout="formItemLayout" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item ref="appcode"  label="AppCode" prop="appcode">
            <span class="form_span" style="font-size:16px;font-weight:bold;" @blur="
                    () => {
                        $refs.appcode.onFieldBlur();
                    }
                    ">{{appData.appcode ? appData.appcode :'空' }}</span>
            <a-button type="primary" style="margin-left:20px;" @click="handleSelectAppcode"  v-if="type != 'editapp'">
                点击选择
            </a-button>
        </a-form-model-item>

        <a-form-model-item ref="domain" label="领域" prop="domain">
            <a-radio-group v-model="appData.domain"  button-style="solid" v-if="type != 'editapp'">
                <a-radio-button value="001">
                前台
                </a-radio-button>
                <a-radio-button value="002">
                中台
                </a-radio-button>
                <a-radio-button value="003">
                开放
                </a-radio-button>
                <a-radio-button value="004">
                基础
                </a-radio-button>
            </a-radio-group>

            <span v-else  style="font-size:16px;font-weight:bold;">{{domainName[appData.domain]}}</span>
        </a-form-model-item>

        <a-form-model-item ref="authflag" label="授权标识" prop="authflag" >
            <a-radio-group v-model="appData.authflag" button-style="solid">
                <a-radio-button value="0">
                不开启
                </a-radio-button>
                <a-radio-button value="1">
                开启白名单
                </a-radio-button>
                <a-radio-button value="2">
                开启黑名单
                </a-radio-button>
            </a-radio-group>

        </a-form-model-item>



        <a-form-model-item ref="authappcodes" v-show="appData.authappcodes != ''" label="授权系统应用编码" prop="authappcodes">
            <!-- <span class="form_span">{{appData.authappcodes}}</span> -->
            <a-button type="primary" v-if="is_vue_task" @click="handleSelectAuthedApp">
                点击授权
            </a-button>

               <!-- 授权列表 -->
        <a-table :columns="colunns_apps" :data-source="authedAppData"  :pagination="false" :loading="tLoading" rowKey="appcode" >
        <template slot="operation" slot-scope="text, record">
            <div class="editable-row-operations">
            <span style="margin-left:15px;">
                    <a-popconfirm  @confirm="() => onAuthedAppDelete(record)"  v-if="is_vue_task">
                        <template slot="title">
                            <p>{{ '确认将【' + record.appname+ '】删除？' }}</p>
                        </template>
                    <a>删除</a>
                    </a-popconfirm>
                </span>
            </div>
        </template>
        </a-table>

        </a-form-model-item>


        <a-form-model-item :wrapper-col="{ span: 14, offset: 14 }" v-show="is_vue_task">
            <a-button type="primary" @click="handleOk">
                保存
            </a-button>
            <a-button style="margin-left: 10px;" @click="handleCancel">
                取消
            </a-button>
        </a-form-model-item>
    </a-form-model>
    <AppSelecter :modalState="modalState" @onModalHide="onAppselecterHide"></AppSelecter>
</a-card>
</div>

</template>
<script>
import AppSelecter from '@/components/AppSelecter'
const m_title = {
    'addapp':'新增App授权',
    'detailapp':'查看App授权',
    'editapp':'编辑App授权',
};
const domainName = {
    '001':'前台',
    '002':'中台',
    '003':'开放',
    '004':'基础',

};
const colunns_apps = [
    {
        title: '系统编码',
        dataIndex: 'syscode',
        align: 'center',
    },
    {
        title: '应用编码',
        dataIndex: 'appcode',
        align: 'center',
    },
    {
        title: '应用英文简称',
        dataIndex: 'appenname',
        align: 'center',
    },
    {
        title: '应用中文简称',
        dataIndex: 'appname',
        align: 'center',
    },
    {
        title: '操作',
        dataIndex: 'operation',
        align: 'center',
        scopedSlots: { customRender: 'operation' },
    }
];
export default {
    data() {
        return {
            type:'',
            colunns_apps:colunns_apps,
            authedAppData:[],
            c_title:'',
            domainName,
            appData:{},
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            rules: {

                appcode: [
                    { required: true, message: '请选择应用编码' , trigger: 'blur' },
                ],
                authflag:[
                    { required: true, message: '请选择授权标识'},
                ],
                domain:[
                    { required: true, message: '请选择领域' },
                ],
            },
            readonlyed:'readonly',
            confirmLoading: false,
            formItemLayout:'horizontal',
            is_vue_task : true,
            disabled: this.$route.params.action == "orgdetail" ? true : false,
            modalState:{//选择app弹框
                isShow:false,
                rowsType:'radio', // or 'checkbox'，单选或多选
                selectkeys:[],
                authedAppData:[],
            },
            tLoading:false,
        };
    },

    methods: {
        onAuthedAppDelete(aItem){
            console.log(aItem)
            this.authedAppData = this.authedAppData.filter(item=>{return item.appcode != aItem.appcode})
            this.appData.authappcodes = JSON.stringify(this.authedAppData)
        },
        handleOk(){
            let that = this;
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    const { params } = that.$route;

                    if(params.action == 'editapp'){
                        let c_params = {
                            id:that.appData.id,
                            appcode:that.appData.appcode,
                            authflag:that.appData.authflag,
                            domain:that.appData.domain,
                            authappcodes:that.appData.authappcodes,
                        }
                        //编辑
                        that.$store
                            .dispatch({
                                type: "servicekey/addOrUpdateApp",
                                params: {...c_params,urlparams:false}
                            })
                            .then((response) => {
                                console.log(response)
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'addapp'){
                        //新增
                        that.$store
                            .dispatch({
                                type: "servicekey/addOrUpdateApp",
                                params: {...that.appData,urlparams:false}
                            })
                            .then((response) => {
                                console.log(response)
                                if(response.data.success == '1'){
                                    that.handleCancel();
                                    that.confirmLoading = false;
                                }

                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        handleSelectAppcode(){
            this.modalState.rowsType = 'radio';
            this.modalState.selectkeys = this.appData.appcode ? [this.appData.appcode] : [];
            this.modalState.flag = 0;
            this.modalState.isShow = true;

        },
        handleSelectAuthedApp(){
            if(this.appData.authappcodes == '[]'){
                this.modalState.selectkeys = [];
            }
            else{
                let tempKeys = [];
                let tData = JSON.parse(this.appData.authappcodes)
                for (let index = 0; index < tData.length; index++) {
                    const element = tData[index];
                    tempKeys.push(element.appcode)
                }
                this.modalState.selectkeys = tempKeys;
            }
            this.modalState.authedAppData = this.authedAppData;
            this.modalState.rowsType = 'checkbox';
            this.modalState.filterAppcode = this.appData.appcode
            this.modalState.flag = 1;
            this.modalState.isShow = true;
        },
        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
        onAppselecterHide(result){
            if(result == undefined){
                this.modalState.isShow = false;
                return;
            }
            if(this.modalState.rowsType == 'radio'){
                this.appData.appcode = result.length > 0 ? result[0].appcode : ''
            }
            else if(this.modalState.rowsType == 'checkbox'){
                this.appData.authappcodes = result.length > 0 ?  JSON.stringify(result) : '[]';
                this.authedAppData = JSON.parse(this.appData.authappcodes)
            }
            this.modalState.isShow = false;
        },
    },
    computed: {

    },
    components:{
        AppSelecter
    },
    mounted(){
        const { query, params } = this.$route;
        let that = this;
        that.type = params.action;
        that.c_title = m_title[params.action];
        if (params.action != "addapp") {
            that.$store.dispatch({
                type: "servicekey/getAuthedAppList",
                params:query
            }).then((res)=>{
                console.log(res);
                that.tLoading = false;
                let result = res.data.data;
                if(result.list.length > 0){
                    that.appData = result.list[0];
                    that.authedAppData = JSON.parse(that.appData.authappcodes)
                }
            })
        }
        else{
            that.appData = {
                id:'',
                appcode:'',
                authflag:'0',
                domain:'001',
                authappcodes:'[]',
            }
        }
        that.is_vue_task = params.action != 'detailapp'

    }
};
</script>

<style scoped>

</style>
